import { Link } from "react-router-dom"
import React, { useState, useEffect } from 'react';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
SwiperCore.use([Navigation]);

function handleClick(e, listItems, setListItem, index) {

    e.preventDefault();

    let listItemCopy = [...listItems];
    listItemCopy.map((item, key) => key === index ? item.selected = true : item.selected = false);
    setListItem(listItemCopy);
    //setListItem(listItems=>({...listItems,"title":item.title,"name":item.name,"link":"","selected":false}))
    //setListItem(listItems=>({...listItems,[index]: {"title":item.title,"name":item.name,"link":"","selected":true}}))
}

let SwipeTab = ({ listItems, setListItem }) => {
    //const [listItems, setListItem] = useState([]);
    return (
        <div className="si_tab pager_tab">
            <Swiper
                spaceBetween={50}
                slidesPerView={2}
                allowTouchMove={false}
                navigation
            >
                {listItems.map((item, index) =>
                    <SwiperSlide key={index} onClick={(event) => handleClick(event, listItems, setListItem, index)} >
                        <Link to="#">{item.title}</Link>
                    </SwiperSlide>)}
            </Swiper>
        </div>
    )
    //{listItems.map((item, index ) => <li key={index} ><Link to={item.link}><img src={require("../../"+item.name).default} alt={item.name}></img></Link></li>)}
}

let SwipeContent = ({ listItems }) => {
    return (
        <div className="si_con">
            <div className="si_box">
                {listItems.map((item, index) => item.selected ? <div className="si_img active" key={index}><img src={require("../../" + item.name).default} alt={item.name}></img></div> : <div key={index}></div>)}
            </div>
            <div className="si_more">
                <div className="si_img">
                    <picture>
                        <source srcSet={require("../../image/img_si_more_m.webp").default} type="image/webp" media="(max-width:767px)" />
                        <img src={require("../../image/img_si_more.png").default} alt="" />
                    </picture>
                </div>
                <div className="si_btn"><Link to="/container/commodity/CommodityPlan">立即了解</Link></div>
            </div>
        </div>
    )
    //{listItems.map((item, index ) => <li key={index} ><Link to={item.link}><img src={require("../../"+item.name).default} alt={item.name}></img></Link></li>)}
}
let Pager = () => {
    const [listItems, setListItem] = useState([]);
    useEffect(() => {
        // fetch("/apt/pager/")
        fetch(process.env.REACT_APP_PAGER_API)
            .then(res => res.json())
            .then((result) => {
                for (var i = 0; i < result.length; i++) {
                    if (i === 0)
                        result[i].selected = true;
                    else
                        result[i].selected = false;
                }
                setListItem(result);
            }).catch(err => {
                throw new Error(err)
            })
    }, [])
    return (
        <div className="section service_index" id="section1">
            <div className="service_con">
                <div className="pagesize">
                    {/* <BrowserRouter> */}
                    <SwipeTab listItems={listItems} setListItem={setListItem} />
                    <SwipeContent listItems={listItems} />
                    {/* </BrowserRouter> */}
                </div>
            </div>
        </div>
    )
}

export default Pager;